import React from 'react';
import { Link } from 'react-router-dom';
import { projects } from '../data/projects';
import './Projects.css';

function Projects() {
  return (
    <main className="projects">
      <div className="projects-header">
        <div className="section-label">{'// All projects'}</div>
        <p className="projects-sub">
          A collection of work spanning mathematics, machine learning, and systems.
        </p>
      </div>
      <div className="projects-grid">
        {projects.map((p) => (
          <Link to={`/projects/${p.id}`} key={p.id} className="proj-card" style={{ borderLeftColor: p.color }}>
            <div className="proj-card-top">
              <span className="proj-tag" style={{ background: p.color }}>{p.tag}</span>
              {p.hasDemo && <span className="demo-badge">[ live demo ]</span>}
            </div>
            <div className="proj-title">{p.title}</div>
            <div className="proj-subtitle">{p.subtitle}</div>
            <div className="proj-desc">{p.description.slice(0, 120)}...</div>
            <div className="proj-tech">
              {p.tech.map((t) => (
                <span key={t} className="tech-pill">{t}</span>
              ))}
            </div>
          </Link>
        ))}
      </div>
    </main>
  );
}

export default Projects;